import React, { useEffect, useState } from "react";

import Card from "../../uiComponents/LDCard";
import CardItem from "../../uiComponents/LDCardItem";
import { ChevronRight, Plus } from "../../../commonComponents/icons/icon";
import SpaceDonationService, { Service } from "src/spaceDonationService";
import LoaderComponent from "../../../commonComponents/appComponents/loader/LoaderComponent";
import { useMutation } from "react-query";
import { contextPath } from "src/constants";
import "./styles.css";
import { Chip } from "@livingdesign/react";
import { Check } from "@livingdesign/icons";

const service: Service = SpaceDonationService;

export interface Props {
  data: any;
  setAddNewOrganization: any;
  setAddNewVerifiedOrganization: any;
  setVerifiedOrganizationData: any;
}

class LandingProfileCard extends React.Component<Props> {
  public render() {
    return <ProfileChooser {...this.props} />;
  }
}

const titleCase = (str: any) =>
  str
    ?.trim()
    ?.split(" ")
    ?.map((w: any) => w[0]?.toUpperCase() + w?.substring(1)?.toLowerCase())
    ?.join(" ");

// @ts-ignore
export { LandingProfileCard };

const ProfileChooser = (props: any) => {
  const mutation = useMutation((data: any) => service.setMyOrgData(data));
  useEffect(() => {
    if (mutation.isSuccess) {
      props.history.push({
        pathname: `${contextPath}/space-donation/create`,
        state: "",
      });
    }
  }, [mutation.isSuccess]);
  return (
    <div className="landingProfileCard-container">
      {mutation.isLoading && <LoaderComponent />}
      {!mutation.isLoading && (
        <Card className="landingProfileCard-card">
          <CardItem>
            <div className="onboarding-info">
            You have selected "Local Community Group” where you must register and undergo manual verification to request space outside of Walmart facilities. Please note: this process can take up to 5 weeks. Once you apply to be reviewed, you will be notified of your approval status by email after the verification process is complete. Please ensure each local community group is registered only once. {" "}
            </div>
            <br />
            <div className="onboarding-info">
            As a local community group, you are an organization that is not associated with any Public Charity 501c3, NCES School, Government Entity (non 501c3), or Other Nonprofit (on the IRS business master file). Upon review if you have realized your organization does not qualify as a local community group, you can access the Storefront Reservation Tool through the Spark Good portal by visiting&nbsp;
            <a href="https://www.walmart.com/nonprofits" target="_blank" rel="noopener noreferrer">
              www.walmart.com/nonprofits
            </a>&nbsp;
            and select your current entity type to start the verification process. 
          </div>
            <br />
            <div className="landingProfileCard-header-content">
            Select a local community group
            </div>
          </CardItem>
          <CardItem className="profile-card-list">
            <div className="landingProfileCard-orglist-container">
            {
              props.data?.spaceOrganization?.myOrgs &&
              props.data.spaceOrganization.myOrgs
                .filter((org: { cybergrantsOrganizationId: string; isWalmartVerified: boolean; }) => 
                  (!org.cybergrantsOrganizationId || org.cybergrantsOrganizationId === '') && 
                  org.isWalmartVerified !== false
                )
              .map((org: any, index: any) => {
                  return (
                    <OrgNameCards
                      key={index}
                      mutation={mutation}
                      {...props}
                      org={org}
                      orgContacts={props.data.spaceOrganization.orgContactList}
                    />
                  );
                })
            }
            </div>
          </CardItem>
          <CardItem className="landingProfileCard-card">
            <div
              className="landingProfileCard-addorg"
              onClick={() => props.setAddNewOrganization(true)}
            >
              <Plus
                style={{ fill: "#0072ea", fontSize: "2.5rem", margin: "auto" }}
              />
              <div className="profile-card-orgname">Register a new local community group</div>
            </div>
          </CardItem>
        </Card>
      )}
    </div>
  );
};

const OrgNameCards = (props: any) => {

  const [status, setStatus] = useState('');

  const {isWalmartVerified } = props.org;


  const renderClassNameOnCondition = () => {
    const statusClassMap: Record<string, string> = {
      active: "chip-status-active", 
      underReview: "chip-status-under-review", 
    };
  
    const className = `chip-status-common ${
      isWalmartVerified
        ? statusClassMap.active 
        : statusClassMap.underReview 
    }`;
  
    return className;
  };
  
  useEffect(() => {
    if (isWalmartVerified) {
      setStatus('Active'); 
    } else {
      setStatus('Under Review'); 
    }
  }, [isWalmartVerified]);
  
  return (
    <div
      className="landingProfileCard-orgname"
      onClick={() => {
        if (
          props.org.orgAddress &&
          Object.keys(props.org.orgAddress).length > 0 &&
          isWalmartVerified 
        ) {
          props.setVerifiedOrganizationData({
            cid: props.data.userId,
            orgId: props.org.orgId,
            cybergrantsOrganizationId: props.org.cybergrantsOrganizationId,
            orgPhoneNumber: null,
            orgName: props.org.orgName,
            orgAddressLine1: props.org.orgAddress.addressLineOne,
            orgAddressLine2: props.org.orgAddress.addressLineTwo,
            orgCity: props.org.orgAddress.city,
            orgState: props.org.orgAddress.state,
            orgZip: props.org.orgAddress.zip,
            primaryContactFname: props.data.firstName,
            primaryContactLname: props.data.lastName,
            primaryContactEmail: props.data.email,
            primaryContactNum: props?.data?.phoneNumber,
            orgOwner: props.org.orgOwner,
            isVerified: props.org.isVerified,
            onboardingStatus: props.org.onboardingStatus,
          });
          props.setAddNewVerifiedOrganization(true);
        } else {
          props.mutation.mutate({
            cid: props.data.userId,
            orgId: props.org.orgId,
            contactDetails: {
              contactType: null,
              cid: props.data.userId,
              firstName: props?.data?.firstName,
              lastName: props?.data?.lastName,
              email: props?.data?.email,
              phoneNumber: props?.data?.phoneNumber,
            },
          });
        }
      }}
    >
      <div>{titleCase(props.org.orgName)}</div>
      <div className="landingProfileCard-orglist-icon">
        <div className="chip-org-status">
          <Chip
            leading={isWalmartVerified ? <Check size="small" /> : null}
            size="small"
            UNSAFE_className={renderClassNameOnCondition()}
          >
            {status}
          </Chip>
        </div>
        <div className="chip-chevron-container">
          <ChevronRight />
        </div>
      </div>
    </div>
  );
};

export { OrgNameCards };
export default LandingProfileCard;
